<script>
import {
  productListMethods,
  productListComputed,
  layoutMethods,
  erpFixMessages,
} from "@/state/helpers";
// import Multiselect from "vue-multiselect";
import { getModuleAccess } from "@/router/helper.js";
import { XlsxRead, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx/dist/vue-xlsx.es";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Product Suggestion Mass Upload",
  },
  components: {
    // Multiselect,
    XlsxRead,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  data() {
    return {
      productList: [],
      folder: "product-images",
      pagination: {
        rows: 10,
        page: 1,
        keyword: "",
        field: null,
        brand: "",
        group: "",
        dateRange: "",
        sort: "id",
        orderDesc: true,
      },
      pageOptions: [10, 20, 30, 40, 50, 60, 60, 70, 80, 90, 100],
      fieldsProductListing: [
        // {
        //   key: "image",
        //   sortable: false,
        // },
        {
          key: "productName",
          sortable: false,
        },
        {
          key: "brandName",
          sortable: false,
        },
        {
          key: "businessCategory",
          sortable: false,
        },
        {
          key: "productCategory",
          sortable: false,
        },
        {
          key: "unitOfMeasurement",
          sortable: false,
        },
        {
          key: "SRP",
          sortable: false,
        },
        {
          key: "cost",
          sortable: false,
        },
        {
          key: "productCode",
          sortable: false,
        },
      ],
      productTemplateItem: {
        productName: "",
        categoryIds: [],
        groupId: null,
        brandId: null,
        srp: "",
        cost: "",
        uom: "",
        productCode: "",
      },
      productSuggestionModule: {
        access: {
          create: true,
          delete: true,
        },
      },
      file: null,
      sheets: [
        { 
          name: "Sheet1", 
          data: [
            {
              // img: "Filename ex. product_photo.png",
              name: "Product Name ex. Nescafe Creamy White",
              brand_id: "Refer to Brands sheet. Should be 1 brand id only.",
              brand: "Product Brand name. Refer to Brands sheet. Should be 1 brand only.",
              business_category_id: 'Refer to Business Categories sheet. Could be multiple and comma-separated',
              business_category: "Refer to Business Categories sheet. Could be multiple and comma-separated",
              product_category_id: "Refer to Product Categories sheet. Should be 1 product category id only.",
              product_category: "Refer to Product Categories sheet. Should be 1 product category only.",
              uom_id: "Refer to Unit of Measurements sheet. Should be 1 uom id only.",
              uom: "Piece, Kilogram, etc. Refer to Unit of Measurements sheet. Should be 1 uom only.",
              srp: "Product SRP",
              cost: "Product Cost",
              sku: "Product Unique Code",
            }
          ] 
        },
        {
          name: "Product Categories",
          data: [ { name: "Product Categories", } ]
        },
        {
          name: "Business Categories",
          data: [ { name: "Business Categories", } ]
        },
        {
          name: "Brands",
          data: [ { name: 'Brand Name', } ]
        },
        {
          name: "Unit of Measurements",
          data: [ { name: 'Unit of Measurements', } ]
        }
      ],
      brands: [],
      business_categories: [],
      product_categories: [],
      measurements: [],
      productSuggestions: [],
      hasErrors: false,
      invalidProductFields: [],
      invalidProducts: [],
      isProductSuggestionsPopulated: true,
      isInvalidProductsPopulated: false
    };
  },
  computed: {
    ...productListComputed,
    ...erpFixMessages,
  },
  async mounted() {
    this.listProductBrands({
      rows: 99999,
      sort: "name",
      orderDesc: false,
    }).then(() => {
      this.brands = this.productBrands.map((brand) => ({
        id: brand.productId,
        name: brand.productBrandName,
      }));
    });
    this.listProductGroups({
      rows: 99999,
      sort: "name",
      orderDesc: false,
    }).then(() => {
      this.product_categories = this.productGroups.map((group) => ({
        id: group.groupId,
        name: group.groupName,
      }));
    });
    this.listBusinessCategories({ rows: 99999 }).then(() => {
      this.business_categories = this.businessCategories.map((category) => ({
        id: category.productId,
        name: category.productName,
      }));
    });
    this.getUnitOfMeasureList().then(() => {
      this.measurements = this.unitOfMeasurementList.map((uom) => ({
        id: uom.id,
        name: uom.name,
        method: uom.method,
        unit: uom.unit,
      }));
    });

    this.changeTitle({ title: "Product Suggestion Mass Upload" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Product Template", to: { name: "Product" } },
        { text: "Product Suggestion", to: { name: "Product Template" } },
        { text: "Mass Upload", to: { name: "" } },
      ],
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess(
      "Utilities",
      "Product Template",
      "Product Suggestion"
    ).then((access) => (this.productSuggestionModule.access = access));

    this.productSuggestions = JSON.parse(JSON.stringify(this.productSuggestionList));
  },
  methods: {
    ...layoutMethods,
    ...productListMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;

      if (this.brands.length > 0 && this.business_categories.length > 0 && 
            this.product_categories.length > 0 && this.measurements.length > 0) {
        if (!Object.hasOwn(item, 'name') || !Object.hasOwn(item, 'brand_id') || !Object.hasOwn(item, 'brand') || 
            !Object.hasOwn(item, 'business_category_id') || !Object.hasOwn(item, 'business_category') || 
            !Object.hasOwn(item, 'product_category_id') || !Object.hasOwn(item, 'product_category') || 
            !Object.hasOwn(item, 'uom_id') || !Object.hasOwn(item, 'uom') || !Object.hasOwn(item, 'srp') || 
            !Object.hasOwn(item, 'cost') || !Object.hasOwn(item, 'sku')) {
                this.hasErrors = true;
                return "table-danger";
        }
    
        if (Object.hasOwn(item, 'business_category_id')) {
            if (this.isInvalidProductsPopulated) return;
    
            let business_category_ids = (""+item.business_category_id).split(',').map(i => i.trim());
    
            for (let i of business_category_ids) {
                if (this.business_categories.find(({ id }) => id == parseInt(i)) == null) {
                    this.hasErrors = true;
                    return "table-danger";
                }
            }
        }
        
        if (Object.hasOwn(item, 'business_category')) {
            if (this.isInvalidProductsPopulated) return;
    
            let bus_categories = item.business_category.split(',').map(i => i.trim());
            for (let i of bus_categories) {
                if (this.business_categories.find(({ name }) => name.toLowerCase() == i.toLowerCase()) == null) {
                    this.hasErrors = true;
                    return "table-danger";
                }
            }
        }

        if (Object.hasOwn(item, 'brand_id')) {
          if (this.brands.find(({ id }) => id == item.brand_id) == null) {
            this.hasErrors = true;
            return "table-danger";
          } 
        }

        if (Object.hasOwn(item, 'brand')) {
          if (this.brands.find(({ name }) => name == item.brand) == null) {
            this.hasErrors = true;
            return "table-danger";
          }
        }

        if (this.product_categories.find(({ id }) => id == item.product_category_id) == null ||
            this.product_categories.find(({ name }) => name == item.product_category) == null ||
            this.measurements.find(({ id }) => id == item.uom_id) == null ||
            this.measurements.find(({ name }) => name == item.uom) == null) {
              this.hasErrors = true;
              return "table-danger";
        }
      }

      console.log('hasErrors: ', this.hasErrors)
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    async output(event) {
      await this.setProductSuggestionList(event).then(() => {
        this.isInvalidProductsPopulated = false;
        this.isProductSuggestionsPopulated = true;
        this.invalidProducts = [];
        this.productSuggestions = [];
        this.productSuggestions = JSON.parse(JSON.stringify(event));
        this.hasErrors = false;
      });
    },
    ifHasError(item) {
      switch (item.itemToCheck) {
        case "brand": 
          if (this.brands.length > 0 ) {
            return this.brands.find(({ name }) => name.toLowerCase() == item.name.trim().toLowerCase()) == null
            ? true : false;
          }
          break;
        case "business": {
          if (this.business_categories.length > 0) {
            let bus_categories = item.name.split(',').map(i => i.trim());
            let arr = []
            for (let i of bus_categories) {
                if (this.business_categories.find(({ name }) => name.toLowerCase() == i.toLowerCase()) == null) arr.push({ value: true});
                else arr.push({ value: false});
            }
            return arr.find(({ value }) => value == true) != null ? true : false;
          }
          break;
        }
        case "product":
          if (this.product_categories.length > 0) {
            return this.product_categories.find(({ name }) => name.toLowerCase() == item.name.trim().toLowerCase()) == null
              ? true : false;
          }
          break;
        case "uom":
          if (this.measurements.length > 0) {
            return this.measurements.find(({ name }) => name.toLowerCase() == item.name.trim().toLowerCase()) == null
              ? true : false;
          }
          break;
      }
    },
    async submitProducts() {
        if (!this.hasErrors) {
            let finalProductSuggestions = JSON.parse(JSON.stringify(this.productSuggestions));
            for (let i = 0; i < finalProductSuggestions.length; i++) {
                for (let j = 0; j < this.measurements.length; j++) {
                    if (finalProductSuggestions[i].uom_id == this.measurements[j].id) {
                        finalProductSuggestions[i].uom = this.measurements[j];
                    }
                }
                finalProductSuggestions[i].business_category_id = (""+finalProductSuggestions[i].business_category_id).split(',').map(i => parseInt(i.trim()));
                finalProductSuggestions[i].business_category = finalProductSuggestions[i].business_category.split(',').map(i => i.trim());
                finalProductSuggestions[i].sku = finalProductSuggestions[i].sku.toString();
            }
            await this.bulkCreateProductTemplate({ list: finalProductSuggestions }).then((data) => {
                this.productSuggestions = [];
                if (data.status == 'ok') {
                    if (data.message.insertedProducts > 0 && data.message.invalidProducts.length == 0) {
                        Swal.fire(
                            "Creation Completed",
                            "",
                            "success"
                        );
                    } else if (data.message.invalidProducts.length > 0) {
                        // this.fieldsProductListing.push({ key: 'remarks', sortable: false })
                        this.isProductSuggestionsPopulated = false;
                        this.isInvalidProductsPopulated = true;
                        this.invalidProductFields = JSON.parse(JSON.stringify(this.fieldsProductListing));
                        this.invalidProductFields.push({ key: 'remarks', sortable: false })
                        this.invalidProducts = data.message.invalidProducts;
                        this.hasErrors = true;
                        Swal.fire(
                            "Creation completed but some records are not saved",
                            "Please check the remarks of each invalid records.",
                            "warning"
                        );
                    } else if (data.message.insertedProducts == 0 && data.message.invalidProducts.length == 0) {
                        Swal.fire(
                            "No Product Suggestion Created",
                            "Please check for some incorrect input or try again later.",
                            "warning"
                        );
                    }
                } else {
                    Swal.fire(
                        "Unexpected Error(s) Occur",
                        data.message,
                        "warning"
                    );
                }
            })
        } else {
            Swal.fire(
                "Errors Encountered",
                "Please check for some errors.",
                "warning"
            );
        }
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title">
                    <span class="fw-normal ms-lg-2">{{
                      isProductSuggestionsPopulated ? `${productSuggestions.length} Record(s)` : `${invalidProducts.length} Invalid Record(s)`
                    }}</span>
                  </h5>
                </div>
              </div>
              <div class="col-md-8 col-sm-8">
                <div class="d-flex justify-content-lg-end mb-lg-3">
                  <b-form-group label="">
                    <b-button 
                      variant="primary" 
                      type="button" 
                      @click="$refs.exportExcelBtn.click()" 
                      class="px-2 btn btn-primary h-fit me-2"
                    >
                      <i class='uil uil-download-alt me-1'></i> Download Template
                    </b-button>
                  </b-form-group>
                  <b-form-group label="">
                    <b-button
                      variant="primary"
                      type="button"
                      @click="$refs.importExcelBtn.value = null; $refs.importExcelBtn.click()"
                      class="px-2 btn btn-primary h-fit me-2"
                    >
                      <i class="uil uil-import me-1"></i> Import
                    </b-button>
                  </b-form-group>
                  <b-form-group label="" v-if="productSuggestionModule.access.create">
                    <b-button
                      :disabled="hasErrors || productSuggestions.length == 0"
                      variant="primary"
                      type="button"
                      @click="submitProducts()"
                      class="px-2 btn btn-primary h-fit me-2"
                    >
                      Submit
                    </b-button>
                  </b-form-group>
                  <b-form-group label="">
                    <b-button
                      variant="primary"
                      type="button"
                      @click="$router.go(-1)"
                      class="px-2 btn btn-primary h-fit"
                    >
                      Close
                    </b-button>
                  </b-form-group>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->

            <!-- table -->
            <template v-if="isProductSuggestionsPopulated">
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="productSuggestions"
                    :fields="fieldsProductListing"
                    :no-local-sorting="true"
                    :tbody-tr-class="rowClass"
                    :per-page="pagination.rows"
                    :current-page="pagination.page"
                    ref="productTable"
                    hover
                  >
                    <!-- <template #cell(action)="row">
                      <div class="d-flex">
                        <button
                          class="btn btn-sm btn-danger"
                          @click="deleteProdTemplate(row.item)"
                        >
                          <i class="bx bx-trash bx-xs bx-fw"></i>
                        </button>
                      </div>
                    </template> -->

                    <!-- <template #cell(image)="row">
                      {{ row.item.img }}
                    </template> -->

                    <template #cell(productName)="row">
                      {{ row.item.name }}
                    </template>

                    <template #cell(brandName)="row">
                      <div
                        :class="{
                          error: ifHasError({
                            itemToCheck: 'brand',
                            id: row.item.brand_id,
                            name: row.item.brand,
                          }),
                        }"
                      >
                        {{ row.item.brand }}
                      </div>
                    </template>

                    <template #cell(businessCategory)="row">
                      <div
                        :class="{
                          error: ifHasError({
                            itemToCheck: 'business',
                            id: row.item.business_category_id,
                            name: row.item.business_category,
                          }),
                        }"
                      >
                        {{ row.item.business_category }}
                    </div>
                    </template>

                    <template #cell(productCategory)="row">
                      <div
                        :class="{
                          error: ifHasError({
                            itemToCheck: 'product',
                            id: row.item.product_category_id,
                            name: row.item.product_category,
                          }),
                        }"
                      >
                        {{ row.item.product_category }}
                    </div>
                    </template>

                    <template #cell(unitOfMeasurement)="row">
                      <div
                        :class="{
                          error: ifHasError({
                            itemToCheck: 'uom',
                            id: row.item.uom_id,
                            name: row.item.uom,
                          }),
                        }"
                      >
                        {{ row.item.uom }}
                    </div>
                    </template>

                    <template #cell(SRP)="row">
                      {{ Object.hasOwn(row.item, 'srp') ? `₱ ${row.item.srp.toFixed(2)}` : '' }}
                    </template>

                    <template #cell(cost)="row">
                       {{ Object.hasOwn(row.item, 'cost') ? `₱ ${row.item.cost.toFixed(2)}` : '' }}
                    </template>

                    <template #cell(productCode)="row">
                      {{ row.item.sku }}
                    </template>
                  </b-table>
                </div>
              </div>
            </template>
            <div class="row g-0 text-center" v-if="productSuggestions.length == 0 && !isInvalidProductsPopulated">
              <span>No data to display.</span>
            </div>
            <div
              class="row g-0 text-center text-sm-start"
              v-if="productSuggestions.length > 10"
            >
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label"
                        >Display:</label
                      >
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select
                            class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="productSuggestions.length"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            
            <!-- invalid products table -->
            <template v-if="isInvalidProductsPopulated">
              <div class="table-responsive" >
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="invalidProducts"
                    :fields="invalidProductFields"
                    :no-local-sorting="true"
                    :per-page="pagination.rows"
                    :current-page="pagination.page"
                    ref="productTable"
                    hover
                  >
                    <!-- <template #cell(action)="row">
                      <div class="d-flex">
                        <button
                          class="btn btn-sm btn-danger"
                          @click="deleteProdTemplate(row.item)"
                        >
                          <i class="bx bx-trash bx-xs bx-fw"></i>
                        </button>
                      </div>
                    </template> -->

                    <!-- <template #cell(image)="row">
                      {{ row.item.img }}
                    </template> -->

                    <template #cell(productName)="row">
                      {{ row.item.name }}
                    </template>

                    <template #cell(brandName)="row">
                      {{ row.item.brand }}
                    </template>

                    <template #cell(businessCategory)="row">
                      {{ row.item.business_category.join(', ') }}
                    </template>

                    <template #cell(productCategory)="row">
                      {{ row.item.product_category }}
                    </template>

                    <template #cell(unitOfMeasurement)="row">
                      {{ row.item.uom.name }}
                    </template>

                    <template #cell(SRP)="row">
                      {{ Object.hasOwn(row.item, 'srp') ? `₱ ${row.item.srp.toFixed(2)}` : '' }}
                    </template>

                    <template #cell(cost)="row">
                       {{ Object.hasOwn(row.item, 'cost') ? `₱ ${row.item.cost.toFixed(2)}` : '' }}
                    </template>

                    <template #cell(productCode)="row">
                      {{ row.item.sku }}
                    </template>

                    <template #cell(remarks)="row">
                      {{ row.item.remarks }}
                    </template>
                  </b-table>
                </div>
              </div>
            </template>
            <div
              class="row g-0 text-center text-sm-start"
              v-if="invalidProducts.length > 10"
            >
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label"
                        >Display:</label
                      >
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select
                            class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="invalidProducts.length"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
          <!-- end card body -->

          <!-- excel template -->
          <template>
            <section class="no-height">
              <xlsx-workbook>
                <xlsx-sheet
                  :collection="sheet.data"
                  v-for="sheet in sheets"
                  :key="sheet.name"
                  :sheet-name="sheet.name"
                />
                <xlsx-download filename="Product-Suggestion-Template.xlsx">
                  <button ref="exportExcelBtn">Download</button>
                </xlsx-download>
              </xlsx-workbook>
            </section>
          </template>

          <template>
            <div class="no-height">
              <input type="file" @change="onChange" ref="importExcelBtn" />
              <xlsx-read :file="file">
                <xlsx-json @parsed="output">
                  <template #default="{ collection }">
                    <div>
                      {{ collection }}
                    </div>
                  </template>
                </xlsx-json>
              </xlsx-read>
            </div>
          </template>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>

<style>
.no-height {
  height: 0;
  display: none;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 14px;
}

.multiselect__placeholder {
  font-size: 14px;
}

.multiselect__single {
  padding-left: 0px;
}

.custom-input {
  width: 97%;
  margin-left: 10px;
  height: 39px;
}

.error {
  color: #f34e4e;
}
</style>
